module.exports = __webpack_public_path__ + "static/media/cq_documento_letto b.7111cef5.svg";